import { useQuery } from '@apollo/client';
import { GetRoadDetailsById } from '../../../../graphql/Mutation';
import { Navigate, useParams } from 'react-router-dom';
import {
  Consumption,
  DaysComponent,
  RoadsUserQualificationsList,
  RoadInfo
} from './components/index';
import { Col, Row } from 'reactstrap';

const RoadDetailsPage = () => {
  const { id } = useParams();
  const { data, loading, error } = useQuery(GetRoadDetailsById, {
    variables: {
      id
    },
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'network-only'
  });

  if (loading) {
    return null;
  }

  if (error) {
    return <Navigate to="/roads/list" />;
  }

  const { getRoadDetailsById: _data } = data;

  return (
    <Row>
      <Col md={9}>
        <Row>
          <Col md={12}>
            <RoadInfo data={_data} />
          </Col>
          <Col md={12}>
            <RoadsUserQualificationsList id={id} />
          </Col>
        </Row>
      </Col>
      <Col md={3}>
        <Row>
          <Col md={12}>
            <DaysComponent data={_data.pillars} />
          </Col>
          <Col md={12}>{/* <Consumption data={Consumo} /> */}</Col>
        </Row>
      </Col>
    </Row>
  );
};

export default RoadDetailsPage;
